// extracted by mini-css-extract-plugin
module.exports = {"title":"BuildingObjects_title__e_Ga3","filters":"BuildingObjects_filters__MOeCn","filtersGroup":"BuildingObjects_filtersGroup__p57qy"};